/* src/app/components/leads/provider-enrollment-forms/provider-enrollment-forms.component.css */
.provider-enrollment-forms {
  width: 100%;
  height: 100%;
  display: block;
  background: #fff;
}
.loading-container,
.error-container,
.no-forms-container {
  padding: 40px;
  text-align: center;
}
.error-message {
  color: #ff4d4f;
  font-weight: 500;
}
.enrollment-wizard {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-top: 10px;
}
.wizard-header {
  padding: 8px 24px;
  border-bottom: 1px solid #e8e8e8;
  background: #004c4a;
}
.wizard-header h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #fff;
  margin: 0 0 8px 0;
}
.wizard-subtitle {
  font-size: 13px;
  color: #fff;
  margin: 0;
  line-height: 1.5;
}
.wizard-content {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.wizard-sidebar {
  width: 360px;
  max-height: 70vh;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #e8e8e8;
  overflow-y: auto;
}
.form-navigation {
  display: flex;
  flex-direction: column;
}
.nav-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 14px 24px;
  border: none;
  background: transparent;
  color: #4a7c9e;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
  position: relative;
  gap: 6px;
}
.nav-item:has(.nav-item-icon) {
  padding-right: 52px;
}
.nav-item:hover {
  background: #e6f7ff;
  color: #1890ff;
}
.nav-item.active {
  background: #e6f7ff;
  color: #1890ff;
  border-left-color: #1890ff;
  font-weight: 600;
}
.nav-item-title {
  font-size: 14px;
  font-weight: 500;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}
.nav-item-status {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.status-complete {
  color: #52c41a;
}
.status-incomplete {
  color: #faad14;
}
.nav-item-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  cursor: default;
}
.incomplete-icon {
  background: #faad14;
}
.completed-icon {
  background: #52c41a;
}
.checklist-group-header {
  padding: 12px 24px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: #004c4a;
}
.checklist-group-header.incomplete {
  background: #8fb3b2;
}
.sidebar-divider {
  margin: 8px 0;
  border: none;
  border-top: 1px solid #d9d9d9;
}
.nav-item-unavailable {
  padding: 14px 24px;
  background: #f5f5f5;
  border-left: 3px solid #ff4d4f;
  opacity: 0.7;
  cursor: not-allowed;
}
.nav-item-error {
  font-size: 11px;
  color: #ff4d4f;
  font-weight: 500;
  margin-top: 4px;
  display: block;
}
.wizard-main {
  flex: 1;
  background: #fff;
  overflow-y: auto;
  padding-left: 24px;
}
.w9-confirmation-note {
  margin: 16px 8px 16px 0;
}
.wizard-navigation {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-top: 1px solid #e8e8e8;
  background: #f0f7ff;
  flex-shrink: 0;
}
.nav-buttons {
  display: flex;
  gap: 12px;
}
@media (max-width: 768px) {
  .wizard-content {
    flex-direction: column;
  }
  .wizard-sidebar {
    width: 100%;
    max-height: 200px;
    border-right: none;
    border-bottom: 1px solid #e8e8e8;
  }
  .nav-item {
    padding: 12px 16px;
  }
  .wizard-navigation {
    flex-direction: column;
    gap: 12px;
  }
  .nav-buttons {
    width: 100%;
    justify-content: space-between;
  }
}
/*# sourceMappingURL=provider-enrollment-forms.component-BSYOHTUV.css.map */
